import React from "react";
import {useTranslation} from "react-i18next";

interface NameInputProps {
  firstName: string;
  setFirstName: (value: string) => void;
  lastName: string;
  setLastName: (value: string) => void;
  isFirstNameValid: boolean;
  isLastNameValid: boolean;
  firstNameErrorMessage: string;
  lastNameErrorMessage: string;
}

export const NameInput: React.FC<NameInputProps> = ({
                                                      firstName,
                                                      setFirstName,
                                                      lastName,
                                                      setLastName,
                                                      isFirstNameValid,
                                                      isLastNameValid,
                                                      firstNameErrorMessage,
                                                      lastNameErrorMessage,
                                                    }) => {
  const { t } = useTranslation();
  return (
    <div className="my-4">
      <label className="block text-sm font-medium mb-2 text-left">
        {t('SignupFullName')}
      </label>
      <div className="grid grid-cols-2 gap-2">
        {/* First Name Input */}
        <input
          type="text"
          id="firstName"
          placeholder={t('SignupFirstName')}
          className={`rounded-md px-3 py-2 bg-white text-black border-2 ${
            isFirstNameValid ? "border-black" : "border-red-500"
          }`}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />

        {/* Last Name Input */}
        <input
          type="text"
          id="lastName"
          placeholder={t('SignupLastName')}
          className={`rounded-md px-3 py-2 bg-white text-black border-2 ${
            isLastNameValid ? "border-black" : "border-red-500"
          }`}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>
      {/* Error Messages */}
      <div className="grid grid-cols-2 gap-2">
        {!isFirstNameValid && (
          <p className="text-red-500 text-sm mt-2">{firstNameErrorMessage}</p>
        )}
        {!isLastNameValid && (
          <p className="text-red-500 text-sm mt-2">{lastNameErrorMessage}</p>
        )}
      </div>
    </div>
  );
}